(function() {
    /**
     * The main initialization function.
     * Finds all containers and passes them to the Evvnt plugin.
     */
    const initializeAllWidgets = () => {
        if (typeof evvnt_require !== 'function') {
            console.error("Evvnt Loader: Plugin loaded but 'evvnt_require' is missing.");
            return;
        }

        const widgets = document.querySelectorAll('[data-vendor="evvnt"]');
        
        widgets.forEach(container => {
            const elementId = container.id;
            if (!elementId) return;

            const getAttr = (name) => container.getAttribute(`data-${name}`);
            const getBool = (name) => getAttr(name) === 'true';
            
            const publisherId = getAttr('publisher-id');
            const partnerName = getAttr('partner');
            if (!publisherId) {
                console.warn(`Evvnt Loader: Missing 'data-publisher-id' for widget ${elementId}`);
            }
            const orientation = getAttr('orientation');
            const categoryRaw = getAttr('category');
            const categoryParsed = parseInt(categoryRaw, 10);
            const categoryId = Number.isFinite(categoryParsed) ? categoryParsed : null;
            const numberRaw = getAttr('number');
            const numberParsed = parseInt(numberRaw, 10);
            const numberSafe = Number.isFinite(numberParsed) ? Math.max(1, Math.min(50, numberParsed)) : 10;
            const config = {
                publisher_id: publisherId,
                discovery: {
                    element: `#${elementId}`,
                    detail_page_enabled: getBool('detail'),
                    widget: getBool('widget'),
                    virtual: false,
                    map: getBool('map'),
                    category_id: categoryId,
                    backfill_events_have_images: getBool('backfill'),
                    orientation: orientation,
                    number: numberSafe
                },
                submission: {
                    partner_name: partnerName
                }
            };
            try {
                evvnt_require("evvnt/discovery_plugin").init(config);
            } catch (err) {
                console.error(`Error initializing Evvnt widget ${elementId}:`, err);
            }
        });
    };

    /**
     * Logic to inject the main Evvnt library script
     */
    const loadMainEvvntScript = () => {
        // Prevent double loading
        if (document.querySelector('script[src*="evvnt_discovery_plugin"]')) return;

        const script = document.createElement('script');
        script.async = true;
        script.src = "//discovery.evvnt.com/prd/evvnt_discovery_plugin-latest.min.js";
        script.setAttribute('data-blox-script', 'true');
        
        // Use the onload event to trigger our config function
        script.addEventListener('load', initializeAllWidgets);
        
        document.head.appendChild(script);
    };

    /**
     * Entry Point: Only load the library if there are widgets on the page
     */
    const start = () => {
        const widgets = document.querySelectorAll('[data-vendor="evvnt"]');
        if (widgets.length > 0) {
            loadMainEvvntScript();
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();